module.exports = __webpack_public_path__ + "assets/60af8fbbc8f51e666b4567d5abcf3ebd.png";